export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const LOGOUT_USER = 'LOGOUT_USER';
